import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations/en';
import { translations as esTranslations } from '../translations/es';

const AssemblageInfo = () => {
  const { language } = useLanguage();
  const t = language === 'en' ? translations : esTranslations;
  return (
    <div className="bg-[#fcf8f2] rounded-md p-4 shadow-sm border border-[#efe5d0]">
      <h3 className="text-xl font-playfair mb-2 text-[#181c24]">{language === 'en' ? 'About Assemblage' : 'Acerca de Assemblage'}</h3>
      <p className="text-xs md:text-[11px] text-[#181c24] mb-4 font-light">
        {language === 'en'
          ? "Creating unique celebrations that capture the essence of your love story in Mexico's most enchanting destinations."
          : "Creamos celebraciones únicas que capturan la esencia de tu historia de amor en los destinos más encantadores de México."}
      </p>
      <ul className="list-none pl-0 space-y-2">
        <li className="flex items-start gap-2 text-[11px] text-[#181c24] font-normal">
          <span className="text-[#e3c27b] mt-1">&#10003;</span> {language === 'en' ? 'Local expertise, international standards' : 'Experiencia local, estándares internacionales'}
        </li>
        <li className="flex items-start gap-2 text-[11px] text-[#181c24] font-normal">
          <span className="text-[#e3c27b] mt-1">&#10003;</span> {language === 'en' ? 'Customized experiences that reflect your vision' : 'Experiencias personalizadas que reflejan tu visión'}
        </li>
        <li className="flex items-start gap-2 text-[11px] text-[#181c24] font-normal">
          <span className="text-[#e3c27b] mt-1">&#10003;</span> {language === 'en' ? 'Seamless planning from start to finish' : 'Planeación perfecta de principio a fin'}
        </li>
      </ul>
  </div>
);
};

export default AssemblageInfo; 